module.exports = __webpack_public_path__ + "static/fourpcrainbowmain-6c635e6169f4ab2a2801018322ee66fd.jpeg";